/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formphonenumber_Placeholder2Inputs */

const ja_contact_formphonenumber_placeholder2 = /** @type {(inputs: Contact_Formphonenumber_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`09012345678`)
};

const en_contact_formphonenumber_placeholder2 = /** @type {(inputs: Contact_Formphonenumber_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eg. +81364197260`)
};

/**
* | output |
* | --- |
* | "eg. +81364197260" |
*
* @param {Contact_Formphonenumber_Placeholder2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formphonenumber_placeholder2 = /** @type {((inputs?: Contact_Formphonenumber_Placeholder2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formphonenumber_Placeholder2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formphonenumber_placeholder2(inputs)
	return en_contact_formphonenumber_placeholder2(inputs)
});
export { contact_formphonenumber_placeholder2 as "contact_formPhoneNumber_placeholder" }